export default function minifyCSSString(style) {
  return style.replace(/\s{2,}/g, '');
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/fela-bindings/node_modules/fela/es/minifyCSSString.js
// module id = 1132
// module chunks = 0